import type { RuleTrait } from '@/app/graphql/rule-engine/rule-engine';
import sdkRuleEngineService, { PaymentPage } from '@/app/graphql/rule-engine/rule-engine';

import type { OperationTypes } from '@/shared/services/payment';
import type { TimeRuleOptions } from '@/shared/services/rule-engine/types';

import { formatQDateOption } from '@/shared/lib/date';

import { mapRulesToRuleMap, mapRuleStringToRegexp } from './helps';

export async function getTransferValidationRules(page: PaymentPage) {
  const response = await sdkRuleEngineService.getPaymentValidationRulesByPage({ page });
  return mapRuleStringToRegexp(response.getPaymentValidationRules);
}

export async function getWorkingDays(isWorkingDay: boolean = true, operation: string | null = null) {
  const response = await sdkRuleEngineService.getWorkingDays({ isWorkingDay, operation });
  return response.getWorkingDays.map((date) => formatQDateOption(date));
}

export async function getOperationsTimeRule() {
  const response = await sdkRuleEngineService.getOperationsTimeRule();
  return response.getOperationsTimeRule;
}

export async function getRuleOptions(
  page: PaymentPage,
  paymentRefs?: RuleTrait[],
  isWorkingDay: boolean = true,
  operation: string | null = null
) {
  const response = await sdkRuleEngineService.getRuleOptions({ page, isWorkingDay, operation });
  const rules = mapRuleStringToRegexp(response.getPaymentValidationRules);
  const ruleMap = mapRulesToRuleMap(rules, paymentRefs);
  const workingDays = response.getWorkingDays.map((date) => formatQDateOption(date));
  return {
    ruleMap,
    workingDays,
    timeRules: response.getOperationsTimeRule,
  };
}

export async function getTimeRuleOptions(
  operation: OperationTypes,
  isWorkingDay: boolean = true,
  operationType: string | null = null
): Promise<TimeRuleOptions> {
  const response = await sdkRuleEngineService.getTimeRuleOptions({ isWorkingDay, operation: operationType });
  const workingDays = response.getWorkingDays.map((date) => formatQDateOption(date));
  return {
    workingDays,
    timeRules: response.getOperationsTimeRule[operation],
  };
}

export async function getSwiftRules(isWorkingDay: boolean = true, operation: string | null = null) {
  const response = await sdkRuleEngineService.getRuleOptions({ page: PaymentPage.Swift, isWorkingDay, operation });
  const rules = mapRuleStringToRegexp(response.getPaymentValidationRules);
  const workingDays = response.getWorkingDays.map((date) => formatQDateOption(date));
  return {
    rules,
    workingDays,
    timeRules: response.getOperationsTimeRule,
  };
}
